import { makeStyles } from '@material-ui/core/styles';

const fontGeneral = (fontSize, fontWeight, lineHeight, color) => {
    var result = {
        fontFamily: ['"Brown"'].join(','),
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        color: color,
    }
    return result;
};


const FormStyles = makeStyles((theme) => ({
   
    form: {
        padding: '0px 20px',
        [theme.breakpoints.down('xs')]: {
            padding: '0px 0px',
        },
    },

    formBoxs: {
        display: 'flex',

        '& div': {
            width: '100%',
        },

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },

    formBoxs_1: {
        marginRight: '40px',

        [theme.breakpoints.down('xs')]: {
            marginRight: '0px',
        },
    },

    pLabel: {
        fontFamily: ['"Brown"'].join(','),
        letterSpacing: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '1.4',
        color: '#000000',
        fontSize: '20px',
        textAlign: 'left',
        margin: '5px 0px 2px 0px',

        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },

    pText: {
        fontFamily: ['"Brown"'].join(','),
        letterSpacing: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '1.4',
        color: '#000000',
        textAlign: 'left',
        fontSize: '20px',
        margin: '20px 0px 40px 0px',

        [theme.breakpoints.down('xs')]: {
            fontSize: '18px',
        },
    },

    texBoxes: {
        fontFamily: ['"Brown"'].join(','),
        width: '100%',
        //height: '48px',
        '& label': {
            color: '#2d3436',
            fontFamily: ['"Brown"'].join(','),
            transform: 'translate(14px, 15px) scale(1)',
        },
        '& div': {
            height: '48px',
            '& input': {
                padding: '14.0px 14px',
            },
        },
        '& p': {
            marginTop: '0px',
        },

        '& .MuiOutlinedInput-root': {
            borderRadius: '0px',

            '& fieldset': {
                borderColor: '#000000',
                border: 'solid 1.5px #000000',
            },
            '&:hover fieldset': {
                borderColor: '#146fd1',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#146fd1',
            },
            '& .MuiInputAdornment-positionStart': {
                marginRight: '0px',
                color: '#b2bec3',

                '& img': {
                    width: '20px',
                    marginRight: '5px',
                },
            },
        },
        [theme.breakpoints.down('sm')]: {
            // width: '522px !important',
            // height: '48px',
        },
        [theme.breakpoints.down('xs')]: {
            // width: '272px !important',
            // height: '65px',
        },
    },
    textBoxesFill: {
        fontFamily: ['"Brown"'].join(','),
        width: '100%',
        //height: '48px',
        '& label': {
            color: '#2d3436',
            fontFamily: ['"Brown"'].join(','),
            transform: 'translate(14px, 15px) scale(1)',
        },
        '& div': {
            height: '48px',
            '& input': {
                padding: '14.0px 14px',
            },
            '& fieldset': {
                border: 'solid 1.5px #146fd1',
            },
            '& .MuiInputAdornment-positionStart': {
                marginRight: '0px',
                color: '#b2bec3',

                '& img': {
                    width: '20px',
                    marginRight: '5px',
                },
            },
        },
        '& p': {
            marginTop: '0px',
        },
        [theme.breakpoints.down('sm')]: {
            // width: '522px !important',
            // height: '48px',
        },
        [theme.breakpoints.down('xs')]: {
            // width: '272px !important',
            // height: '65px',
        },
    },

    textAreaBoxes: {
        fontFamily: ['"Brown"'].join(','),
        width: '100%',
        height: '128px',
        '& label': {
            color: '#2d3456',
            fontFamily: ['"Brown"'].join(','),
            transform: 'translate(14px, 15px) scale(1)',
            '&.Mui-focused': {
                color: '#2d3456',
            }
        },
        '& div': {
            height: '128px',
            '& input': {
                padding: '14.0px 14px',
            },
        },
        '& p': {
            marginTop: '0px',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '0px',

            fontFamily: ['"Brown"'].join(','),
            '& fieldset': {
                borderColor: '#000000',
                border: 'solid 1.5px #000000',
            },
            '&:hover fieldset': {
                borderColor: '#146fd1',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#146fd1',
            },
        }
    },

    textAreaBoxesFill: {
        fontFamily: ['"Brown"'].join(','),
        width: '100% ',
        height: '128px',
        '& label': {
            color: '#2d3436',
            fontFamily: ['"Brown"'].join(','),
            transform: 'translate(14px, 15px) scale(1)',
            '&.Mui-focused': {
                color: '#2d3436',
            },
        },
        '& div': {
            height: '128px',
            '& input': {
                padding: '14.0px 14px',
            },
            '& fieldset': {
                border: 'solid 1.5px #146fd1',
            },
        },
        '& p': {
            marginTop: '0px',
        },
        '& .MuiOutlinedInput-root': {
            fontFamily: ['"Brown"'].join(','),
            '&:hover fieldset': {
                borderColor: '#146fd1',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#146fd1',
                '& label': {
                    color: '#ff00ff',
                },
            },
        },
    },

    pContent: {
        fontFamily: ['"Brown"'].join(','),
        letterSpacing: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '1.4',
        color: '#FFFFFF',
        textAlign: 'left',
        fontSize: '64px',
        display: 'flex',
        alignItems: 'center',
        padding: '0px 150px',
        position: 'absolute',
        marginTop: '300px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 70px',
            fontSize: '48px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0px 50px',
            marginTop: '150px',
            fontSize: '40px',
        },
    },

    boxText: {
        fontFamily: ['"Brown"'].join(','),
        letterSpacing: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        fontWeight: '300',
        lineHeight: '1.4',
        color: '#000000',
        textAlign: 'left',
        fontSize: '18px',
        alignItems: 'center',
        padding: '0px 208px',
        marginTop: '150px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 70px',
            // fontSize: '48px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0px 50px',
            marginTop: '100px',
            // fontSize: '40px',
        },
    },

    spaceFooter: {
        height: '8px',
        position: 'fixed',
        background: '#008CFF',
        width: '100%',
        top: '0px',
        zIndex: '2000',
    },

    pTittle: {
        margin: '0 0 24px',
        fontSize: '18px',
        fontFamily: '"Archia"',
        fontWeight: '700',
    },

    pBold: {
        margin: '0 0 24px',
        fontWeight: 'bold',
    },

    pSubTittle: {
        margin: '0 0 24px',
        fontWeight: 'bold',
        textDecorationLine: 'underline',
    },
    pParagraph: {
        margin: '0 0 24px',
        [theme.breakpoints.down('xs')]: {
            // margin: '0px',
        },
    },

    list_1: {
        listStyleType: 'lower-latin',
    },

    list_2: {
        counterReset: 'item',
    },

    list_3: {
        display: 'block ',

        '&:before': {
            content: 'counters(item, ".") " "',
            counterIncrement: 'item',
        },
    },

    list_4: {
        listStyleType: 'none',
        counterReset: 'item',
        margin: '0',
        padding: '0',

        '& li': {
            display: 'table',
            counterIncrement: 'item',
            marginBottom: '0.6em',

            '&:before': {
                content: 'counters(item, ".") " "',
                display: 'table-cell',
                paddingRight: '0.6em',
            },
        },
    },

    list_num: {
        listStyleType: 'decimal',
        fontWeight: 'bold',
    },

    contentButton: {
        display: 'flex',
        '& :hover':{
            backgroundColor: '#000000',
        },
    },

    buttonBlack:{
        padding: '16px 48px',
        backgroundColor: '#000000',
        ...fontGeneral('21px', 'bold', '1.2', '#ffffff'),
        '& :hover':{
            backgroundColor: '#000000',
        },
    },

    DropdownList: {
        fontFamily: ['Brown'].join(','),
        marginBottom: '24px !important',
        width: '100%',
        '& label': {
          color: '#000000',
          fontFamily: ['"Nunito Sans"', 'sans-serif'].join(','),
          transform: 'translate(14px, 15px) scale(1)',
        },
        '& div': {
          height: '48px',
    
          '& input': {
            padding: '14.0px 14px',
          },
          '& fieldset': {
            border: 'solid 1.5px #000000',
          },
          '& svg': {
            position: 'absolute',
            right: '19px',
            zIndex: '-2',
            fill: '#000000',
            width: '24px',
            height: '24px',
          },
          '& select ': {
            backgroundColor: 'transparent !important',
            width: '100% !important',
          },
        },
        '& p': {
          marginTop: '0px',
        },
        [theme.breakpoints.down('sm')]: {

        },
        [theme.breakpoints.down('xs')]: {

        },
      },
    

}));

export default FormStyles;